var m = require('mithril');
var prop = require('mithril/stream')
var loaders = require('../../layout/components/loaders');
var verticalListItem = require('../../components/verticalListItem');
var paginationWithSearch = require('../../data/components/paginationWithSearch');

function urlForRecord (record) {
  return '/api/v1/' + record['@class'].toLowerCase() + '/' + record['@rid'].slice(1);
}

function getSelectedPointRid(selectedPoint) {
  var value = typeof selectedPoint === 'function' ? selectedPoint() : selectedPoint;
  if (value && typeof value === 'object' && value['@rid']) {
    value = value['@rid'];
  }
  if (typeof value !== 'string' || value.length === 0) {
    return null;
  }
  return value;
}

var component = {};

component.oninit = function oninit (vnode) {
  var state = vnode.state;
  state.node = prop();
  state.newNode = prop(false);
  state.nodeToShow = [];
  
  state.selectNetworkNode = function (networkNode){
    return loaders.requestWithLoader({
      loader: 'background',
      url: '/api/v1/'+networkNode['@class'],
      method: 'GET'
    })
    .then(function (res) {
      state.node(res);
    });

  }

  state.selectNode = function selectNode (nodeId) {
    var params = m.parseQueryString(m.route.get().split('?')[1]);
    params['fieldnetTreeSelectedPoint'] = nodeId.split('/')[4];
    m.route.set(m.route.get().split('?')[0], params, {replace: true});
    
    if (nodeId.split('/')[3] === 'point') {
      return loaders.requestWithLoader({
        loader: 'background',
        url: nodeId + '/resource',
        method: 'GET'
      })
      .then(function (res) {
        var selectedPointRid = getSelectedPointRid(vnode.attrs.selectedPoint);
        if (res && res.children) {
          res.children = res.children.filter(child => child.deleted != true);
          res.children.sort((a, b) => {
            if (
              a['@rid'].toString() === selectedPointRid ||
              a['name'] === "PRESENT_VALUE"
            ) {
              return -1; 
            } else if (b['@rid'].toString() === selectedPointRid) {
              return 1;
            } else {
              return 0;
            }
          })
        }
        state.node(res);
      });
    }
    return loaders.requestWithLoader({
      loader: 'background',
      url: nodeId,
      method: 'GET'
    })
    .then(function (res) {
      if(res.children) res.children = res.children.filter(child => child.deleted != true);
      res.children.sort((a, b) => {
        if (a.name === "PRESENT_VALUE" && b.name !== "PRESENT_VALUE") {
          return -1;
        }
        if (b.name === "PRESENT_VALUE" && a.name !== "PRESENT_VALUE") {
          return 1;
        }
        return 0;
      });
      state.node(res);
      state.newNode = prop(true);
    });
  }
  state.selectRoot = function selectRoot () {
    
    vnode.state.node({children:
      [
        {name: 'BACnet', '@class':'BacnetServer'},
        {name: 'Lontalk', '@class':'LontalkCnip'},
        {name: 'Modbus', '@class':'ModbusTcp'},
        {name: 'HTTP', '@class':'RestHttp'},
        {name: 'Aggregates', '@class': 'aggregate'}
      ]
    })
  }
  
  var selectedPointRid = getSelectedPointRid(vnode.attrs.selectedPoint);
  if (selectedPointRid) {
    var params = m.parseQueryString(m.route.get().split('?')[1]);
    params['fieldnetTreeSelectedPoint'] = selectedPointRid;
    m.route.set(m.route.get().split('?')[0], params, {replace: true});
    vnode.state.selectNode('/api/v1/point/' + selectedPointRid.slice(1));
  } else {
    if (!vnode.attrs.ignoreRouteSelection && m.route.param('fieldnetTreeSelectedPoint')) {
      vnode.state.selectNode('/api/v1/point/' + m.route.param('fieldnetTreeSelectedPoint'));
    } else {
      vnode.state.selectRoot();
    }
  }
}

component.view = function (vnode) {
  var vm = vnode.state;
  return m('div', [
    m("div.pb2.bb.bw1.b--mid-gray.near-white.mt2",  [
      m('div.dib-ns.mr2.blue.f3', {onclick: ()=>vm.selectRoot()}, "Home"),
      m('dib-ns.mr2.f3', '/'),
      function () {
        if(!vm.node()) return 
        if (vm.node().breadcrumbs) {
          return vm.node().breadcrumbs.map(function (crumb, idx){
            return m('div.dib-ns.mr2', {
              class:(idx+1) === vm.node().breadcrumbs.length ? "active" : "blue", 
              onclick: vm.selectNode.bind(this, urlForRecord(crumb)), 
              //config: m.route
            }, [
              crumb.name,
              m('span.near-white', ' / ')
            ])
          })        
        } else if (vm.node() === vm.aggregates) {
          return m('div.dib-ns.mr2.f3', "Aggregates");
        } else if (vm.node()['@class'] === 'Aggregate') {
          return m('div.dib-ns.mr2.blue.f3', {onclick: vm.node.bind(vm, vm.aggregates)}, "Aggregates");
        }
      }()
    ]),
    m('div.mt2', [
      function () {
        if(!vm.node()) return 
        if (vm.node().children && vm.node().children.length && vm.node().children[0]['@class'] === 'Point') {
          return m(paginationWithSearch, {
            data: vm.node().children,
            newNode: vm.newNode,
            dataToShow: vm.nodeToShow
          },[
            vm.nodeToShow.map(function (point) {
              if(!point['@rid']) return;
              var selectedPointRid = getSelectedPointRid(vnode.attrs.selectedPoint);
              return m(verticalListItem, {onclick: vnode.attrs.selectedPoint.bind(this, point['@rid']), label: point.name,}, [
                m('i', {class: 
                  function getPointIcon () {
                    var baseClass = 'fr ';
                    // if (vm.node() === null) { return baseClass + 'ion-ios-circle-outline'};
                    if (selectedPointRid === point['@rid']) {
                      return baseClass + 'ion-ios-circle-filled'
                    }
                    else {
                      return baseClass + 'ion-ios-circle-outline'
                    }
                  }()
                })
              ])
            })
          ])
        } else { 
          var children = vm.node().children || vm.node();
          let mainMenu;
          children.map(function (node) {
            if (['BACnet', 'Lontalk', 'Modbus', 'HTTP', 'Aggregates'].indexOf(node.name) > -1) {
              mainMenu = true
            }
          })
          if(mainMenu){
            return children.map(function (node) {
              return m(verticalListItem, {
                label: node.name,
                onclick: function () {
                  vm.selectNetworkNode(node)
                  //vm.node(vm[node.name.toLowerCase()])
                }
              },[
                  m('i', {class: 'fr ion-ios-arrow-right'})
                ]
              )
            })
          }else{
            return m(paginationWithSearch, {
              data: children,
              newNode: vm.newNode,
              dataToShow: vm.nodeToShow
            },[
              vm.nodeToShow.map(node =>{
                if(!node['@rid']) return;
                return m(verticalListItem, {
                  label: node.name,
                  onclick: vm.selectNode.bind(this, urlForRecord(node)),
                },[
                  m('i', {class: 'fr ion-ios-arrow-right'})
                ])
              })
            ])
          }
        }
      }()
    ])
  ])
}

module.exports = component;
